import React from 'react';
import dynamic from 'next/dynamic';
import { getVirtualTourType } from '@pkgs/components/utils/propertyCardUtils';
import { useCarouselActions } from '@pkgs/components/hooks/useCarouselActions';

import { useExposeModal } from '@/providers/ExposeModalProvider';
import { useListing } from '@/hooks/queries/useListing';

import { ActionButtons } from './ActionButtons';

import styles from './ExposeHeroImage.module.css';

const PropertyImageSlider = dynamic(() => import('./PropertyImageSlider').then((mod) => ({ default: mod.PropertyImageSlider })));

type MobileHeroImageSliderProps = {
  handleImageClick: (index: number) => void;
  showsButtonGroup: boolean;
};

export const MobileHeroImageSlider = ({ handleImageClick, showsButtonGroup }: MobileHeroImageSliderProps) => {
  const {
    data: { listing, genericListing },
  } = useListing();
  const carouselActions = useCarouselActions({ inViewThreshold: 0.1 }, undefined, false);
  const { openMediaModal, setSelectedMediaTab } = useExposeModal();

  if (genericListing.propertyImages?.length === 0) {
    return null;
  }

  const vTourType = getVirtualTourType(listing?.vtourUrlNormalized, listing?.videoUrlNormalized);

  return (
    <div className={styles.propertyImageSlider}>
      <PropertyImageSlider
        images={genericListing.propertyImages ?? []}
        carouselActions={carouselActions}
        hasWaterMark={Boolean(listing?.hasWaterMark)}
        onImageClick={() => handleImageClick(carouselActions.selectedIndex)}
        shouldPreload={false}
      />
      {showsButtonGroup && (
        <ActionButtons
          focusedImageIndex={carouselActions.selectedIndex + 1}
          totalImages={genericListing.propertyImages?.length ?? 0}
          hasFloorPlan={Boolean(listing?.floorPlanImages?.length)}
          vTourType={vTourType}
          onBtnClick={(tab) => {
            setSelectedMediaTab(tab);
            openMediaModal();
          }}
        />
      )}
    </div>
  );
};
